// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"7e35ccdf","732":"08cf4564","977":"86e6b76c"}[chunkId] + ".chunk.js";
};